import { render, staticRenderFns } from "./forgotpassword.vue?vue&type=template&id=48e30e26&scoped=true&lang=html"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"
import style0 from "./forgotpassword.vue?vue&type=style&index=0&id=48e30e26&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e30e26",
  null
  
)

export default component.exports